var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thumbs-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.33333 7.66699V16.3337M9.75583 5.88394L10.0027 3.77728C10.1344 2.6538 9.25644 1.66699 8.12527 1.66699C7.74615 1.66699 7.40372 1.89353 7.25543 2.24245L5.01169 7.52185C4.80249 8.01407 4.31941 8.33366 3.78458 8.33366H3C1.89543 8.33366 1 9.22909 1 10.3337V14.3337C1 15.4382 1.89543 16.3337 3 16.3337H12.1581C13.051 16.3337 13.8358 15.7417 14.0811 14.8831L15.6049 9.54977C15.97 8.27214 15.0106 7.00033 13.6819 7.00033H10.749C10.1506 7.00033 9.68618 6.47828 9.75583 5.88394Z",
    stroke: "#008A00",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/Thumbs-up.ef561ab6d94e4f07f3fa8c92e715e8dc.svg";
export { ForwardRef as ReactComponent };